// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Звіти про прозорість» (Transparency Reports, ключ `trp`, група `advocacy`). */
export const transparencyReportsManifest: IModuleManifest = {
  key: 'trp',
  group: 'advocacy',
  slug: 'transparency-reports',
  prefix: 'TRP',
  name: { en: 'Transparency Reports', uk: 'Звіти про прозорість' },
  entities: [
    { key: 'trp', slug: 'trp', name: { en: 'Transparency Reports', uk: 'Звіти про прозорість' }, main: true },
    { key: 'report_spending_item', slug: 'report-spending-item', name: { en: 'Report Spending Items', uk: 'Статті витрат' }, main: false },
    { key: 'report_activity', slug: 'report-activity', name: { en: 'Report Activities', uk: 'Види діяльності' }, main: false },
    { key: 'report_filing', slug: 'report-filing', name: { en: 'Report Filings', uk: 'Подання звітів' }, main: false },
  ],
  loadState: () => import('./state/transparencyReportsSlice').then((m) => m.transparencyReportsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
